import cn from 'classnames'
import { FC, ReactNode } from 'react'

interface Row {
  className?: string
  space?: boolean
  value?: number
  children?: ReactNode
}

const Row: FC<Row> = ({ children, className, space, ...props }) => (
  <div {...props} className={cn({ 'flex-row': true, space }, className)}>
    {children}
  </div>
)

Row.displayName = 'Row'
export default Row
